function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import React, { memo, useCallback, useMemo, useState } from "react";
import { Box, Skeleton } from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import Pagination from "@mui/material/Pagination";
import { get } from "lodash";
import Blueprint from "./Blueprint";
import ErrorNotice from "../ErrorNotice";
import SectionBox from "../SectionBox";
import { formatAnyValue } from "../../facade/format";
var DataGrid = function(props) {
    var columns = props.columns, rows = props.rows, loading = props.loading, pagination = props.pagination, enableGhostCells = props.enableGhostCells, error = props.error, sectionBoxProps = _object_without_properties(props, [
        "columns",
        "rows",
        "loading",
        "pagination",
        "enableGhostCells",
        "error"
    ]);
    var _useState = _sliced_to_array(useState({}), 2), widthsByIndex = _useState[0], setWidthsByIndex = _useState[1];
    var widths = useMemo(function() {
        return columns.map(function(column, i) {
            var _widthsByIndex_i, _ref;
            return (_ref = (_widthsByIndex_i = widthsByIndex[i]) !== null && _widthsByIndex_i !== void 0 ? _widthsByIndex_i : column.width) !== null && _ref !== void 0 ? _ref : 150;
        });
    }, [
        columns,
        widthsByIndex
    ]);
    var getRowHeaderCellNumber = useCallback(function(rowIndex) {
        return rowIndex + 1 + (pagination ? pagination.page * pagination.rowsPerPage : 0);
    }, [
        pagination
    ]);
    var rowHeaderCellRenderer = useCallback(function(rowIndex) {
        var rowHeaderCellNumber = getRowHeaderCellNumber(rowIndex);
        return /*#__PURE__*/ _jsx(Blueprint.RowHeaderCell, {
            index: rowHeaderCellNumber,
            name: rowHeaderCellNumber.toString(),
            loading: loading
        });
    }, [
        getRowHeaderCellNumber,
        loading
    ]);
    var getCellClipboardData = useCallback(function(rowIndex, colIndex) {
        var row = rows[rowIndex];
        var column = columns[colIndex];
        var val = get(row, column.id);
        return column.formatValue ? column.formatValue(val, row) : formatAnyValue(val);
    }, [
        columns,
        rows
    ]);
    var columnHeaderCellRenderer = useCallback(function(columnIndex) {
        var column = columns[columnIndex];
        var _column_header;
        return /*#__PURE__*/ _jsx(Blueprint.ColumnHeaderCell, {
            "data-testid": "DataGrid-column_header_cell_".concat(columnIndex),
            children: (_column_header = column.header) !== null && _column_header !== void 0 ? _column_header : column.id
        });
    }, [
        columns
    ]);
    var valueRenderer = useCallback(function(column, row) {
        var val = get(row, column.id);
        if (column.renderValue) {
            return column.renderValue(val, row);
        }
        if (column.formatValue) {
            return column.formatValue(val, row);
        }
        return formatAnyValue(val);
    }, []);
    var cellRenderer = useCallback(function(column) {
        return function(rowIndex) {
            if (loading) return /*#__PURE__*/ _jsx(Blueprint.Cell, {
                children: /*#__PURE__*/ _jsx(Skeleton, {
                    width: 60
                })
            });
            var row = rows[rowIndex];
            return /*#__PURE__*/ _jsx(Blueprint.Cell, {
                children: valueRenderer(column, row)
            });
        };
    }, [
        loading,
        rows,
        valueRenderer
    ]);
    var columnRenderer = useCallback(function(column, i) {
        return /*#__PURE__*/ _jsx(Blueprint.Column, {
            id: "".concat(column.id, "-").concat(i),
            name: column.header,
            columnHeaderCellRenderer: columnHeaderCellRenderer,
            cellRenderer: cellRenderer(column)
        }, "".concat(column.id, "-").concat(i));
    }, [
        cellRenderer,
        columnHeaderCellRenderer
    ]);
    var onChangePage = useCallback(function(_, newPage) {
        pagination === null || pagination === void 0 ? void 0 : pagination.onChangePage(newPage - 1);
    }, [
        pagination
    ]);
    var onChangeWidthByIndex = useCallback(function(index, size) {
        setWidthsByIndex(function(pv) {
            return _object_spread_props(_object_spread({}, pv), _define_property({}, index, size));
        });
    }, []);
    return /*#__PURE__*/ _jsx(SectionBox, _object_spread_props(_object_spread({}, sectionBoxProps), {
        children: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                error && /*#__PURE__*/ _jsx(ErrorNotice, {
                    error: error
                }),
                loading && /*#__PURE__*/ _jsx(LinearProgress, {
                    "data-testid": "DataGrid-loading"
                }),
                /*#__PURE__*/ _jsx(Blueprint.Table, {
                    enableGhostCells: enableGhostCells,
                    numRows: rows.length,
                    renderMode: Blueprint.RenderMode.BATCH,
                    columnWidths: widths,
                    defaultRowHeight: 32,
                    onColumnWidthChanged: onChangeWidthByIndex,
                    rowHeaderCellRenderer: rowHeaderCellRenderer,
                    getCellClipboardData: getCellClipboardData,
                    cellRendererDependencies: [
                        loading,
                        columns,
                        rows
                    ],
                    children: columns.map(function(column, i) {
                        return columnRenderer(column, i);
                    })
                }),
                pagination && /*#__PURE__*/ _jsx(Box, {
                    mt: 2,
                    children: /*#__PURE__*/ _jsx(Pagination, {
                        count: Math.ceil(pagination.count / pagination.rowsPerPage),
                        page: pagination.page + 1,
                        onChange: onChangePage,
                        shape: "rounded",
                        color: "standard"
                    })
                })
            ]
        })
    }));
};
export default /*#__PURE__*/ memo(DataGrid);
